const organization = {
    require_membership: '用戶必須是組織的成員才能繼續。',
};
export default Object.freeze(organization);
